import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { WalletFacade } from '../+state/wallet/wallet.facade';

@Injectable({
  providedIn: 'root',
})
export class PresetWalletsGuard implements CanActivate {
  constructor(private readonly walletFacade: WalletFacade) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.walletFacade.triggerPreset(route.paramMap.get('clientId'));
    return true;
  }
}
